import useBrowser from 'shared/services/browser';

export default function useBrowserSvc(db, extensionId) {
  const noopBrowser = {
    runtime: {
      sendMessage() {
        console.error('browser is not supported');
      },
    },
  };

  const getBrowser = () => {
    if (window.chrome === undefined) {
      return noopBrowser;
    }

    if (import.meta.env.DEV && import.meta.env.VITE_BROWSER === 'mock') {
      return useBrowser(db, extensionId);
    }

    return window.chrome;
  };

  return { getBrowser };
}
